import { BaseContainerModel } from '../base-container.model';
import { app_mst_link_subject_to_role_RowClass } from '../../dbschema/app_mst_link_subject_to_role.model';

export class TenantUserRoleContainerModel extends BaseContainerModel {
    link_subject_to_role: app_mst_link_subject_to_role_RowClass =  new app_mst_link_subject_to_role_RowClass();
}